export default [
    {
        path: '/help/sitemap/',
        component: () => import(/* webpackChunkName: "help" */ "@/pages/help/Sitemap"),
        alias: '/WebModules/Help/SiteMap.aspx',
        meta: {menu_id: 'SITEMAP'},
    },
];
